import { render } from "./PlayerEntriesList.vue?vue&type=template&id=1850e8a5&scoped=true"
const script = {}

import "./PlayerEntriesList.vue?vue&type=style&index=0&id=1850e8a5&scoped=true&lang=css"
import "./PlayerEntriesList.vue?vue&type=style&index=1&id=1850e8a5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1850e8a5"]])

export default __exports__